/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Premium_Billed_Yearly_LikeInputs */

const en_premium_billed_yearly_like = /** @type {(inputs: Premium_Billed_Yearly_LikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Billed at ${i?.price}/year, that's like:`)
};

const es_premium_billed_yearly_like = /** @type {(inputs: Premium_Billed_Yearly_LikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturado a ${i?.price}/año, es como:`)
};

/**
* | output |
* | --- |
* | "Billed at {price}/year, that's like:" |
*
* @param {Premium_Billed_Yearly_LikeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_billed_yearly_like = /** @type {((inputs: Premium_Billed_Yearly_LikeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Billed_Yearly_LikeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_billed_yearly_like(inputs)
	return en_premium_billed_yearly_like(inputs)
});